import { render } from "./AddOrderForm.vue?vue&type=template&id=0584ae12"
import script from "./AddOrderForm.vue?vue&type=script&lang=js"
export * from "./AddOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__